export default class ShadersFragment {
    // pass uniforms object
    constructor(uniforms) {
        this._uniforms = uniforms;
        this._functions = {};
        this._main = "";
    }

    functions() {
        if (this._main === "") {
            // if main is empty, functions can not have been computed
            this.main();
        }

        let content = "";
        for (let property in this._functions) {
            content += this._functions[property] + "\n";
        }

        return content;
    }

    uniforms() {
        let content = "";
        for (let property in this._uniforms) {
            let uniform = this._uniforms[property];
            content += `uniform ${uniform.typeGLSL} ${property}`;

            if (uniform && uniform.length) {
                content += `[${uniform.length}]`;
            }

            content += ";\n";
        }

        return content;
    }

    main() {
        // need to pre-call main to fill up the functions list
        this._main = `precision highp float;

float luma (vec3 rgb) {
  return (rgb.r + rgb.g + rgb.b)/3.0;
}

const float T = 0.04;
const float M = 1.0;
const float L = 0.002;

void main(void) {
  // Sobel filter
  // Adapted from https://github.com/mrdoob/three.js/blob/dev/examples/webgl_postprocessing_sobel.html

  float borderWidth = uWidth; // in px
  vec2 resolution = vec2(uCanvasWidth, uCanvasHeight);

  float tx0y0 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(-borderWidth, -borderWidth)) / resolution.xy).a;
  float tx0y1 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(-borderWidth, 0.0)) / resolution.xy).a;
  float tx0y2 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(-borderWidth, borderWidth)) / resolution.xy).a;

  float tx1y0 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(0.0, -borderWidth)) / resolution.xy).a;
  float tx1y1 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(0.0, 0.0)) / resolution.xy).a;
  float tx1y2 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(0.0, borderWidth)) / resolution.xy).a;

  float tx2y0 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(borderWidth, -borderWidth)) / resolution.xy).a;
  float tx2y1 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(borderWidth, 0.0)) / resolution.xy).a;
  float tx2y2 = texture2D(uTextureFilled, (gl_FragCoord.xy + vec2(borderWidth, borderWidth)) / resolution.xy).a;

  const mat3 Gx = mat3( -1, -2, -1, 0, 0, 0, 1, 2, 1 ); // x direction kernel
  const mat3 Gy = mat3( -1, 0, 1, -2, 0, 2, -1, 0, 1 ); // y direction kernel

  float valueGx = Gx[0][0] * tx0y0 + Gx[1][0] * tx1y0 + Gx[2][0] * tx2y0 +
                  Gx[0][1] * tx0y1 + Gx[1][1] * tx1y1 + Gx[2][1] * tx2y1 +
                  Gx[0][2] * tx0y2 + Gx[1][2] * tx1y2 + Gx[2][2] * tx2y2;

  float valueGy = Gy[0][0] * tx0y0 + Gy[1][0] * tx1y0 + Gy[2][0] * tx2y0 +
                  Gy[0][1] * tx0y1 + Gy[1][1] * tx1y1 + Gy[2][1] * tx2y1 +
                  Gy[0][2] * tx0y2 + Gy[1][2] * tx1y2 + Gy[2][2] * tx2y2;

  float G = sqrt( ( valueGx * valueGx ) + ( valueGy * valueGy ) );
  
  // get the color here so it can be manipulated for debugging purposes
  vec3 color = texture2D(uTextureFilled, gl_FragCoord.xy / resolution.xy).rgb;
  
  //
  // -- BEGIN: AVENDA CODE
  //
  
  vec2 n = gl_FragCoord.xy - uMeshCenter.xy;
  float angle = atan(n.y, n.x) * 180.0 / 3.141592;
  float minAngle = 0.0;
  float maxAngle = 90.0;
  
  // If along the x or y axis of the mesh center, just draw a line and return.
  if (uShowAxes) {
      if (abs(n.x) <= 1.0 || abs(n.y) <= 1.0) {
          gl_FragColor = vec4(1.0, 1.0, 1.0, 0.5);
          return;
      }
  }

  // Check if the contour should be dashed. If so, calculate the angle between
  // the projected center and texel being sampled. Contour should be dashed if
  // the dash gap is non-zero and the fragment color is the selected highlight
  // color or we want to make everything dashed
  bool shouldBeDashed = uDashedGap > 0.0
      && (!uDashedHighlightedOnly || color == uHighlightColor);
  if (shouldBeDashed) {
      if (mod(angle, (uDashedLength + uDashedGap)) < uDashedGap) {
          gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
          return;
      }
  }
  
  // Optionally highlight only one quadrant of the prostate.
  if (uQuadrant > 0) {
      if (uQuadrant == 1 /*PROSTATE_QUADRANT.ANTERIOR_LEFT*/) {
          minAngle = 0.0;
          maxAngle = 90.0;
      } else if (uQuadrant == 2 /*PROSTATE_QUADRANT.ANTERIOR_RIGHT*/) {
          minAngle = 90.0;
          maxAngle = 180.0;
      } else if (uQuadrant == 3 /*PROSTATE_QUADRANT.POSTERIOR_LEFT*/) {
          minAngle = -90.0;
          maxAngle = 0.0;
      } else if (uQuadrant == 4 /*PROSTATE_QUADRANT.POSTERIOR_RIGHT*/) {
          minAngle = -180.0;
          maxAngle = -90.0;
      } else /*PROSTATE_QUADRANT.NONE*/ {
          gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
          return;
      }
      
      // don't show quadrants outside the range
      if (angle < minAngle || angle > maxAngle) {
          gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
          return;
      }
  }
  
  // if fully alpha, convert to black for MRI layer shader
  if (G == 0.0) {
      color = vec3(0.0, 0.0, 0.0);
  }
  
  //
  // -- END: AVENDA CODE
  //

  gl_FragColor = vec4(color.rgb, G);
  
  // Check if less than 3 adjacent pixels are blank and if so, discard
  float sum = tx0y0 + tx0y1 + tx0y2 + tx1y0 + tx1y1 + tx1y2 + tx2y0 + tx2y1 + tx2y2;
  if (sum <= 2.0) {
    gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
    return;
  }

  // Guard against erroneous pixels
  if (gl_FragColor.r == 0.0 && gl_FragColor.g == 0.0 && gl_FragColor.b == 0.0) {
    gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
  }
  
  return;
}
   `;
    }

    compute() {
        return `
// uniforms
${this.uniforms()}

// varying (should fetch it from vertex directly)
varying vec4      vProjectedCoords;

// tailored functions
${this.functions()}

// main loop
${this._main}
      `;
    }
}
